'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import RegisterMail from '../components/RegisterMail'
import Channels from '../base/channels'
import Splide from '@splidejs/splide'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--newsletter'
        // Objects
        // Fns
        this.moodletter = new RegisterMail(this.view.querySelector('.jsRegister--page'))
        this.slideshow()
    }

    slideshow()
    {
        // new Splide( '.splide' ).mount();
        const $slideshow = this.view.querySelector('.jsSlideshow--view')
        if($slideshow != null) {
            this.slideshow = new Splide($slideshow , {
                arrows: true,
                arrowPath:false,
                type: 'fade',
                autoplay: true,
                heightRatio:.6,
                interval: 7000,
                rewind: true,
                pauseOnFocus:false,
                pauseOnHover:false,
                pagination:true,
                easing: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                speed: 1000
            }).mount();
        }

    }
}

page = Barba.BaseView.extend({
    namespace: 'newsletter',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {

    },
    onLeave: function()
    {

    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;